export default "__VITE_ASSET__B2q_0o4R__"